import { useQuery } from "@tanstack/react-query";
import { getDossierOriginOption } from "../../../api/service/customerbaseApi";
import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import { CustomerSearchFilters } from "../../../types";

const CBDossierOriginSearchFilter = () => {

    const { t } = useTranslation('customerbase');
    const formContext = useFormContext<CustomerSearchFilters>();

    const dossierOriginQuery = useQuery({
        queryKey: ["getDossierOriginOption"],
        queryFn: getDossierOriginOption,
        enabled: false
    });

    const handleOnOpen = () => {
        if(dossierOriginQuery.data == undefined) 
            dossierOriginQuery.refetch();
    }

    return (
        <Controller
            name={"dossierOrigin"}
            control={formContext.control}
            render={({ field}) =>
                <Autocomplete
                    fullWidth
                    openOnFocus
                    autoHighlight
                    autoSelect
                    options={dossierOriginQuery.data != undefined ? ["", ...dossierOriginQuery.data] : []}
                    value={field.value}
                    onOpen={handleOnOpen}
                    loading={dossierOriginQuery.isLoading}
                    onChange={(_e, value) => {
                        field.onChange(value);
                    }}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={t("dossierOrigin")}
                            fullWidth
                        />
                    } />
            }
        />
    )

}

export default CBDossierOriginSearchFilter;